import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import 'rc-slider/assets/index.css';
import 'assets/fonts/fonts.css';
import './normalize.css';
import './antdOverride.css';
import Provider from 'react-redux/es/components/Provider';
import App from './view/App';
import registerServiceWorker from './registerServiceWorker';
import store from './store';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>, document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js